var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDeploy = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "currentColor",
  viewBox: "0 0 280 280"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m258.605 50.075-19.03 52.332a59.9 59.9 0 0 1-13.947 21.901L160.1 189.836v56.15c0 12.462-15.066 18.702-23.878 9.89L24.125 143.779c-8.812-8.811-2.571-23.877 9.89-23.877h56.15l65.527-65.528a59.9 59.9 0 0 1 21.902-13.949l52.332-19.03c17.86-6.494 35.174 10.821 28.68 28.68M40.211 199.827l39.963 39.964a36.15 36.15 0 0 1-32.331 19.981H20.229V232.16a36.15 36.15 0 0 1 19.982-32.332"
})));
export default SvgDeploy;